/** Com este parâmetro a tela do processo abre o painel no pacote do e-mail e baixa o PDF. */
export const PARAMETRO_PDF_DO_AVISO = 'pdf';

/**
 * Destino do botão do e-mail de "pronto". O e-mail aponta para `/arbitral/:id/autos-pdf/:pacote`
 * (o pacote no CAMINHO), que redireciona para cá: o `proxy.ts` guarda só o caminho no `redirect`
 * do login, e um `?pdf=` direto se perderia para quem abre o e-mail com a sessão vencida.
 */
export function rotaDoProcessoComPdfDoAviso(processoId: string, pacoteId: string): string {
  const parametros = new URLSearchParams({ [PARAMETRO_PDF_DO_AVISO]: pacoteId });
  return `/arbitral/${encodeURIComponent(processoId)}?${parametros.toString()}`;
}

/** A URL atual sem o `?pdf=`, preservando os outros parâmetros da tela (aba etc.). */
export function urlSemPdfDoAviso(pathname: string, parametros: URLSearchParams): string {
  const restantes = new URLSearchParams(parametros.toString());
  restantes.delete(PARAMETRO_PDF_DO_AVISO);
  const busca = restantes.toString();
  return busca ? `${pathname}?${busca}` : pathname;
}
